import api from "./api";

const BASE_SERVICE_URL = "merchant-service";

export default {
    verifyPromoCode(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${BASE_SERVICE_URL}/v1/self-serve/verify/promo-code`, 
                payload
            )
            .then(response => {
                return resolve(response);
            })
            .catch((status, errors) => {
                reject(status, errors);
            });
        });
    },
};
